var map = {
	"./cloudy-day.svg": "c2b8",
	"./cloudy.svg": "1cf9",
	"./rainy.svg": "fe1d",
	"./snowy.svg": "3c07",
	"./sunny.svg": "d8a3",
	"./thunder.svg": "bfb2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c1d0";